import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const elementId = hash.replace('#', '');
      
      const scrollToElement = () => {
        const element = document.getElementById(elementId);
        if (element) {
          // Offset for the dynamic 80px fixed header and extra breathing room
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          return true;
        }
        return false;
      };

      // Try immediately
      if (!scrollToElement()) {
        // Retry a few times in case components are mounting or animating
        let attempts = 0;
        const intervalId = setInterval(() => {
          attempts += 1;
          const success = scrollToElement();
          if (success || attempts >= 10) {
            clearInterval(intervalId);
          }
        }, 100);

        return () => clearInterval(intervalId);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
